var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddImageBu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 26C8 16.0589 16.0589 8 26 8C35.9411 8 44 16.0589 44 26C44 35.9411 35.9411 44 26 44C16.0589 44 8 35.9411 8 26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.25 19.8125H31.0625L30.3031 17.6844C30.2507 17.5388 30.1545 17.4129 30.0278 17.3239C29.9011 17.235 29.7501 17.1874 29.5953 17.1875H22.4047C22.0883 17.1875 21.8047 17.3867 21.6992 17.6844L20.9375 19.8125H17.75C16.7141 19.8125 15.875 20.6516 15.875 21.6875V32.375C15.875 33.4109 16.7141 34.25 17.75 34.25H34.25C35.2859 34.25 36.125 33.4109 36.125 32.375V21.6875C36.125 20.6516 35.2859 19.8125 34.25 19.8125ZM34.4375 32.375C34.4375 32.4781 34.3531 32.5625 34.25 32.5625H17.75C17.6469 32.5625 17.5625 32.4781 17.5625 32.375V21.6875C17.5625 21.5844 17.6469 21.5 17.75 21.5H22.1258L22.5266 20.3797L23.0633 18.875H28.9344L29.4711 20.3797L29.8719 21.5H34.25C34.3531 21.5 34.4375 21.5844 34.4375 21.6875V32.375ZM26 23C23.9281 23 22.25 24.6781 22.25 26.75C22.25 28.8219 23.9281 30.5 26 30.5C28.0719 30.5 29.75 28.8219 29.75 26.75C29.75 24.6781 28.0719 23 26 23ZM26 29C24.7578 29 23.75 27.9922 23.75 26.75C23.75 25.5078 24.7578 24.5 26 24.5C27.2422 24.5 28.25 25.5078 28.25 26.75C28.25 27.9922 27.2422 29 26 29Z",
    fill: "#BDBDBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImageBu);
export default __webpack_public_path__ + "static/media/addImageBu.4dba33ba2c0f4c1ec027deb53a3070ea.svg";
export { ForwardRef as ReactComponent };